import { z } from 'zod';
import { GeometryType, geometryTypeSchema } from './GeometryType';
import { Position, positionSchema } from './Position';

export interface Geometry<T extends GeometryType> {
    type: T;
    coordinates: Position | Position[] | Position[][];
}

export const geometrySchema = z.object({
    type: geometryTypeSchema,
    coordinates: z.union([
        positionSchema,
        z.array(positionSchema),
        z.array(z.array(positionSchema)),
    ]),
});
